export default __webpack_public_path__ + "static/media/r-architecture-MAnVoJlQUvg-unsplash.91a44f8b.jpg";